import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICommitteePublishedDocumentDto } from '../models/committee-published-document';
import { environment } from '../../../../../environments/environment';
import { IApiResponse } from '../../../../shared/models/api-response';


@Injectable({
  providedIn: 'root'
})
export class DocumentService {


    baseUrl: string = `${environment.servicesUrl.document}api/Document`;

    constructor(
      private http: HttpClient,
    ) { }


    getPublishedDocumentsByCommittee(committeeCode: string): Observable<IApiResponse<ICommitteePublishedDocumentDto[]>> {
      return this.http
        .get<IApiResponse<ICommitteePublishedDocumentDto[]>>(`${this.baseUrl}/get-published-documents-by-committee/${committeeCode}`)
    }

}
